<template>
    <div class="article_note relative pl-12 my-5 overflow-auto">
        <!-- image -->
        <template v-if="options.image">
            <image-with-descriptions
                    class="mb-5 -mt-5"
                    :options="{
                                image: options.image,
                                descriptions: options.descriptions || []
                    }"
            />
        </template>

        <!-- vertical content -->
        <template  v-if="options.verticalcontent">
            <span
                    class="article_note__VerticalContent
                        absolute inline-block w-auto top-0 left-0
                        transform -rotate-90
                        origin-top-right -translate-x-full
                    "
                    :class="[
                        (options.fontSize && options.fontSize.verticalcontent) ||
                            `text-base`,
                        (options.color && options.color.verticalcontent) ||
                            `text-cornflower_blue`,
                        (options.margin && options.margin.verticalcontent) ||
                            `mt-0`,
                    ]"
                    v-html="options.verticalcontent"
            ></span>
        </template>


        <!-- title -->
        <template v-if="options.title">
            <h3
                    class="article_note__title"
                    :class="[
                        (options.fontSize && options.fontSize.title) || `text-base`,
                        (options.color && options.color.title) || `text-flamingo`,
                    ]"
                    v-html="options.title"
            ></h3>
        </template>

        <!-- content -->
        <template  v-if="options.content">
            <p
                    class="article_note__content"
                    :class="[
                        (options.fontSize && options.fontSize.content) || `text-base`,
                        (options.color && options.color.content) || `text-flamingo`,
                    ]"
                    v-html="options.content"
            ></p>
        </template>

    </div>
</template>

<script>
export default {
    name: "ArticleNote",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.article_note {

    &__image {
        @apply relative block w-3/4 m-auto;
    }
    &__title {
        @apply mt-5;
    }

    .article_note__VerticalContent{
        min-width: 300px;
        text-align: end;
    }

}
</style>
